module.exports = __webpack_public_path__ + "static/media/mashaAmy.a48196ac.jpeg";